'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignupProductIntents;

var _signupProductIntents = require('../../core/constants/signupProductIntents');

var _signupProductIntents2 = _interopRequireDefault(_signupProductIntents);

var _getMaybeVerifiedConfig = require('../getMaybeVerifiedConfig');

var _FrameEventBus = require('signup-ui-bridge-core/FrameEventBus');

var _FrameEventBus2 = _interopRequireDefault(_FrameEventBus);

var _FrameEventBusContainer = require('../../core/globals/FrameEventBusContainer');

var _FrameEventBusContainer2 = _interopRequireDefault(_FrameEventBusContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_SignupProductIntents = {}, _defineProperty(_SignupProductIntents, _signupProductIntents2.default.crm, function () {
  return import( /* webpackChunkName: "bundles/flow/crm" */'./configs/verified/crm');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.fbCrm, function () {
  return import( /* webpackChunkName: "bundles/flow/fb_crm" */'./configs/fbCrm');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.marketing, function () {
  return import( /* webpackChunkName: "bundles/flow/marketing" */'./configs/verified/marketing');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.sales, _getMaybeVerifiedConfig.getMaybeSalesVerified), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.academy, function () {
  return import( /* webpackChunkName: "bundles/flow/academy" */'./configs/verified/academy');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.classroomTraining, function () {
  return import( /* webpackChunkName: "bundles/flow/classroomTraining" */'./configs/verified/classroomTraining');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.hubspotForStartups, function () {
  return import( /* webpackChunkName: "bundles/flow/hubspotForStartups" */'./configs/verified/hubspotForStartups');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.integrations, function () {
  return import( /* webpackChunkName: "bundles/flow/integrations" */'./configs/verified/integrations');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.purchase, function () {
  return import( /* webpackChunkName: "bundles/flow/purchase" */'./configs/verified/purchase');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.service, function () {
  return import( /* webpackChunkName: "bundles/flow/service" */'./configs/verified/service');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.trial, function () {
  return import( /* webpackChunkName: "bundles/flow/trial" */'./configs/trial');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.trialSignup, function () {
  return import( /* webpackChunkName: "bundles/flow/trialSignup" */'./configs/verified/trialSignup');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.developers, function () {
  return import( /* webpackChunkName: "bundles/flow/developers" */'../standardShort/configs/developers');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.standaloneCmsDeveloper, function () {
  return import( /* webpackChunkName: "bundles/flow/standaloneCmsDeveloper" */'../standardShort/configs/developerContentHub');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.growthHub, function () {
  return import( /* webpackChunkName: "bundles/flow/growthHub" */'../hubless/configs/growthHub');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.wordpress, function () {
  return import( /* webpackChunkName: "bundles/flow/wordpress" */'../marketplace/wordpress/config');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.embedded, function () {
  var frameEventBus = new _FrameEventBus2.default();
  _FrameEventBusContainer2.default.set(frameEventBus);
  return import( /* webpackChunkName: "bundles/flow/embedded" */'../embedded/content/config');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.embeddedCrm, function () {
  return import( /* webpackChunkName: "bundles/flow/genericEmbedded" */'../embedded/allInOne/config').then(function (genericEmbedded) {
    return genericEmbedded.default('crm');
  });
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.embeddedSales, function () {
  return import( /* webpackChunkName: "bundles/flow/genericEmbedded" */'../embedded/allInOne/config').then(function (genericEmbedded) {
    return genericEmbedded.default('sales');
  });
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.embeddedService, function () {
  return import( /* webpackChunkName: "bundles/flow/genericEmbedded" */'../embedded/allInOne/config').then(function (genericEmbedded) {
    return genericEmbedded.default('service');
  });
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.embeddedMarketing, function () {
  return import( /* webpackChunkName: "bundles/flow/genericEmbedded" */'../embedded/allInOne/config').then(function (genericEmbedded) {
    return genericEmbedded.default('marketing');
  });
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.checkout, function () {
  return import( /* webpackChunkName: "bundles/flow/checkout" */'../custom/CheckoutSignup/App');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.standaloneCmsPartner, function () {
  return import( /* webpackChunkName: "bundles/flow/standaloneCmsPartner" */'../custom/PartnerContentHubSignup/App');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.directoryListing, function () {
  return import( /* webpackChunkName: "bundles/flow/directoryListing" */'../custom/DirectoryUserSignup/App');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.salesPartner, function () {
  return import( /* webpackChunkName: "bundles/flow/salesPartner" */'../custom/SalesPartnerSignup/App');
}), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.partnerClient, function () {
  return import( /* webpackChunkName: "bundles/flow/partnerClient" */'../custom/PartnerClientSignup/App');
}), _SignupProductIntents);
module.exports = exports['default'];